/* @flow */
import React, { memo } from 'react';
import { Input } from 'antd';

type Props = {
  onChange: (value?: ?string | ?number) => void,
};

const NumberInput = React.forwardRef((props, ref) => {
  const onChange = (e) => {
    const { value } = e.target;
    const reg = /^-?(0|[1-9][0-9]*)|(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-' || value === '.') {
      props.onChange(value);
    }
  };

  return <Input {...props} ref={ref} onChange={onChange} />;
});
const NumberInputMemo = memo<Props>(NumberInput);
export default NumberInputMemo;
